import { replace } from 'react-router-redux';
import { reset } from 'redux-form';

import apiSubmitEmail from '../../utils/email/emailApi';

import {
    ACTION_COMPLETED_LOCAL_REP,
    EMAIL_COLLECTED,
    onFinishMultiAction
} from '../Widget/actions';

import {
    CLOSE_DOUBLE_CHECK_REP_POPUP
} from '../LocalRep/actions';

export const EMAIL_SUBMITTING = 'EMAIL_SUBMITTING';
export const EMAIL_SUBMITTING_ERROR = 'EMAIL_SUBMITTING_ERROR';
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS';
export const SET_SUCCESS_INFO = 'SET_SUCCESS_INFO';
export const ON_EMAIL_MESSAGE_CHANGE = 'ON_EMAIL_MESSAGE_CHANGE';
export const ON_GO_TO_STEP2 = 'ON_GO_TO_STEP2';
export const ON_BACK_FROM_STEP2 = 'ON_BACK_FROM_STEP2';
export const SET_PREFIX_POPUP_VISIBILITY = 'SET_PREFIX_POPUP_VISIBILITY';

let toasterTimeout = null;

export const onEmailComplete = (
    apiRequestData,
    actionCompletedTime,
    values,
    localRepData,
    isMultiActionsCard,
    activeAction,
    recipientMask,
    representativeSearch,
    emailTopic,
    emailMessage,
    repsEmailed,
    skipEndCard
) => dispatch => {
    dispatch({ type: CLOSE_DOUBLE_CHECK_REP_POPUP });

    dispatch({
        type: EMAIL_SUBMITTING,
        payload: true
    });

    return apiSubmitEmail(
        apiRequestData,
        actionCompletedTime,
        values,
        localRepData,
        representativeSearch,
        emailTopic,
        emailMessage
    )
        .then(data => {
            dispatch({
                type: EMAIL_SUCCESS,
                payload: {
                    ...data,
                    actionIdentifier: activeAction.identifier,
                    recipientMask
                }
            });

            dispatch({
                type: SET_SUCCESS_INFO,
                payload: {
                    repsEmailed,
                    apiRequestData
                }
            });

            dispatch({
                type: ACTION_COMPLETED_LOCAL_REP
            });

            if (values.getUpdates) {
                dispatch({
                    type: EMAIL_COLLECTED,
                    payload: true
                });
            }

            if (isMultiActionsCard) {
                onFinishMultiAction(activeAction.identifier)(dispatch);
            } else if (!skipEndCard) {
                dispatch(replace('/email/success'));
            }

            dispatch({
                type: EMAIL_SUBMITTING,
                payload: false
            });

            dispatch(reset('emailDetailsFormMultiRepStep1'));
            dispatch(reset('emailDetailsFormMultiRepStep2'));
        })
        .catch(errorMessage => {
            dispatch({
                type: EMAIL_SUBMITTING_ERROR,
                payload:
                    'There was an error while submitting your form! Please try again later!'
            });

            if (toasterTimeout != null) {
                clearTimeout(toasterTimeout);
                toasterTimeout = null;
            }

            toasterTimeout = setTimeout(() => {
                toasterTimeout = null;
                dispatch({
                    type: EMAIL_SUBMITTING_ERROR,
                    payload: null
                });
            }, 5000);

            dispatch({
                type: EMAIL_SUBMITTING,
                payload: false
            });
        });
};

export const continueToStep2 = values => dispatch => {
    dispatch({
        type: ON_GO_TO_STEP2,
        payload: values
    });

    dispatch(replace('/email/multiRepStep2'));
};

export const onBackFromStep2 = () => dispatch => {
    dispatch({
        type: ON_BACK_FROM_STEP2,
        payload: true
    });

    dispatch(replace('/email'));

    setTimeout(() => {
        dispatch({
            type: ON_BACK_FROM_STEP2,
            payload: false
        });
    }, 1000);
};

export const onEmailMessageChange = () => dispatch => {
    dispatch({
        type: ON_EMAIL_MESSAGE_CHANGE,
        payload: true
    });
};

export const setPrefixModalVisibility = val => dispatch => {
    dispatch({
        type: SET_PREFIX_POPUP_VISIBILITY,
        payload: val
    });
};
